import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=ef5a5248&lang=html"
import script from "./medical.vue?vue&type=script&lang=js"
export * from "./medical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports